module.exports = __webpack_public_path__ + "img/ul_list.6998e4d3.svg";